<template>
	<div>
		<div class="memberNotice">
			<div class="notice-search">
				<el-select class="select" v-if="pageParams.id!=4" v-model="categorValue" placeholder="公告类型" clearable>
					<el-option v-for="item in categor" :key="item.id" :label="item.text" :value="item.value">
					</el-option>
				</el-select>
				<el-input v-model="input" placeholder="搜索标题" style="width:15.625vw;" clearable></el-input>
				<el-input v-model="companyName" placeholder="输入发布公告公司关键字" style="width:15.625vw;" clearable></el-input>
				<el-button type="primary" @click="search" style="margin-right:1.5vw;">搜索</el-button>
			</div>
			<div style="padding:0 1.5vw">
				<el-table ref="filterTable" :data="tableData" style="width: 100%" :row-class-name="tableRowClassName"
					:header-cell-style="{ 'background-color': 'rgba(32, 137, 255, 0.2)', color: '#2089FF', 'font-weight': '500' }"
					@row-click="rowClick">
					<el-table-column v-for="(item,index) in columnList" :prop="item.prop" :label="item.label">

					</el-table-column>
				</el-table>
				<div style="padding:0.833vw 0 6.25vw;text-align:right;">
					<el-pagination @current-change="topChange" @prev-click="prevClick" @next-click="nextClick"
						:page-size="10" layout="prev, pager, next, jumper" :total="total"></el-pagination>
				</div>
			</div>
			<tab-bottom ref="bottom"></tab-bottom>
		</div>

	</div>
</template>

<script>
	import adver from '@/pages/advertisement.vue';
	import BaseMixin from '@/mixins/BaseMixin.vue';
	import PageMixin from '@/mixins/PageMixin.vue';
	import tabBottom from '@/pages/bottom.vue'
	export default {
		mixins: [BaseMixin, PageMixin],
		data() {
			return {
				input: '',
				tableData: [],
				categorValue: '',
				categor: [],
				total: 0,
				currentPage: {
					page: 0,
					size: 10,
				},
				searchForm: {},
				columnList: [{
					prop: 'noticeType',
					label: '公告类型'
				}, {
					prop: 'noticeTitle',
					label: '公告标题'
				}, {
					prop: 'noticeFirm',
					label: '发布企业'
				}, {
					prop: 'noticeTime',
					label: '发布时间'
				}]
			};
		},
		components: {
			tabBottom,
			adver
		},
		watch: {
			categorValue: {
				handler(newName, oldName) {
					if (newName !== oldName) {
						this.searchForm.categoryName = newName
						this.initList()
					}
				}
			},
			input: {
				handler(newName, oldName) {
					if (newName === '') {
						this.searchForm.title = ''
						this.initList()
					}
				}
			}
		},
		created() {
			if (this.pageParams.id == 4) {
				this.searchForm.categoryId = 4

				this.columnList = [{
					prop: 'noticeTitle',
					label: '培训项目'
				}, {
					prop: 'noticeFirm',
					label: '发布企业'
				}, {
					prop: 'noticeTime',
					label: '发布时间'
				}]
			}
		},
		methods: {
			initData() {
				this.searchForm.type = 1
				this.pageApi = this.$u.api.articleList
				this.initList()
				this.$u.api.articleCategor({
					companyUse: true
				}).then(res => {
					res.data.forEach(e => {
						this.categor.push({
							text: '「' + e.name + ' 」',
							value: e.name,
							id: e.id
						})
					})
				})
			},
			search() {
				this.searchForm.title = this.input
				this.initList()
			},
			reqComplete() {
				const info = []
				this.list.forEach(e => {
					info.push({
						id: e.id,
						noticeType: '「' + e.category.name + '」',
						noticeTitle: e.title,
						noticeFirm: e.company ? e.company.name : '平台',
						noticeTime: this.$dy_tool.formatDate(e.createTime, 'yyyy-MM-dd')
					})
				})
				this.tableData = info
			},
			filterTag(value, row) {
				return row.tag === value;
			},
			filterHandler(value, row, column) {
				const property = column['noticeType'];
				return row.noticeType === value;
			},
			tableRowClassName({
				row,
				rowIndex
			}) {

				if (rowIndex % 2 == 0) {
					// console.log(row)
					return 'warning-row';
				} else {
					return 'success-row';
				}
			},
			rowClick(row) {
				this.jump('notice_detail?id=' + row.id)
			},

			topChange(e) {
				this.currentPage.page = e - 1
				this.getList()
			},
			prevClick(e) {
				this.currentPage.page = e + 1
				this.getList()
			},
			nextClick(e) {
				this.currentPage.page = e - 1
				this.getList()
			},
		}
	};
</script>
<style>
	page {
		background: none;
	}

	.el-table>>>.warning-row {
		background: #FCFCFC;
	}

	.el-table>>>.success-row {
		background: rgba(32, 137, 255, 0.05);
	}
</style>
<style lang="less" scoped>
	.memberNotice {
		margin: 0 auto;
		width: 68.5vw;
		background: #fff;
		box-shadow: 0px 8px13px0px rgba(6, 27, 51, 0.13);

		.notice-search {
			display: flex;
			align-items: center;
			justify-content: flex-end;
			margin-top: 4.125vw;
			width: 100%;

			.el-button {
				float: right;
			}

			.el-input {
				float: right;
				margin-right: 1vw;
			}

			.select {
				margin-right: 20px;
			}
		}

		.el-table {
			margin-top: 1.5625vw;
		}


	}
</style>